import client from './client';

const baseUrl = '/api/v1/project/orders/bill-plan';

// 진입점. 서버가 이 값으로 허용 대상을 다르게 판정한다.
export const ENTRY_ORDER_LIST = 'ORDER_LIST'; // 수주품의서 — 권한자만
export const ENTRY_PROJECT = 'PROJECT';       // 수주관리(프로젝트/유지보수) — 담당·팀장·본부장·권한자

// 프로젝트의 거래처 묶음별 재분배 현황. 재분배는 거래처 단위라 먼저 대상을 골라야 한다.
export const getReplanGroups = (prjUuid, entry = ENTRY_PROJECT) =>
  client.get(`${baseUrl}/list/${prjUuid}`, { params: { entry } });

// 재분배 대상 조회. 잠긴 회차·분배 가능액·권한 여부가 함께 온다.
export const getReplanTarget = (billUuid, entry = ENTRY_PROJECT) =>
  client.get(`${baseUrl}/${billUuid}/replan`, { params: { entry } });

// 재분배 저장. rows 는 발행 미확정 회차만 보낸다.
export const saveReplan = (billUuid, { rows, entryPoint = ENTRY_PROJECT, reason }) =>
  client.put(`${baseUrl}/${billUuid}/replan`, { rows, entryPoint, reason });

// 발행 취소 권한. 재분배보다 강한 행위라 권한자만 가능하다.
export const getCancelIssuePermission = () =>
  client.get(`${baseUrl}/cancel-issue/permission`);

// 버튼 노출 판단용. 차단 자체는 서버가 저장 시점에 한다.
export const getReplanPermission = (roUuid, entry = ENTRY_PROJECT) =>
  client.get(`${baseUrl}/${roUuid}/replan/permission`, { params: { entry } });
